import { useState } from 'react';

interface ShareButtonProps {
  label?: string;
  onShare: () => Promise<void> | void;
  highlight?: boolean;
  compact?: boolean;
  className?: string;
  disabled?: boolean;
}

function classNames(...classes: Array<string | false | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export default function ShareButton({
  label = 'Шерни',
  onShare,
  highlight,
  compact,
  className,
  disabled,
}: ShareButtonProps) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (busy || disabled) return;
    try {
      setBusy(true);
      await onShare();
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      className={classNames(
        'share-btn',
        compact && 'share-btn-compact',
        highlight && 'share-btn-pulse',
        (busy || disabled) && 'share-btn-disabled',
        className
      )}
      onClick={handleClick}
      disabled={disabled || busy}
    >
      <span className="share-icon">⬆</span>
      {busy ? 'Готвя...' : label}
    </button>
  );
}
